"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NpiDashboardData = void 0;
const dashboard_1 = require("../dashboard");
class NpiDashboardData {
}
exports.NpiDashboardData = NpiDashboardData;
//# sourceMappingURL=npi-dashboard-data.response.js.map